import { TimeOption } from '@/entities/time'

export interface FilterRuleOperator {
    name: string
    operator: string
}

export interface IFilterTimeLabel {
    label: string
    from?: string
    to?: string
}

export interface IFilterRule {
    column: string
    operator: string
    value: string[]
}

export interface IFilterQuery {
    name?: string
    time_unit: TimeOption
    time_value: string
    filter_rules?: IFilterRule[]
}

export interface IFilter extends IFilterQuery {
    id?: number // will be null for locked filters (which aren't stored as dashboardfilters)
    user_id?: number
    parent?: number
    is_shared?: boolean
    is_default?: boolean
    locked?: boolean
    question_type: string
}

export interface IFilterOption {
    label: string
    value: string
    common?: boolean
    count?: string | number
    options?: IFilterOption[] // any sub options
}

export interface ITrendLines {
    id: number
    user_id: number
    lines: IFilterRule[]
}

export interface IIndustry {
    id: number
    industry: string
    low?: number
    high?: number
    median?: number
    has_sufficient_data: boolean
}

export interface QuestionTypeOption {
    name: string
    label: string
}

export function getQuestionTypeOptions() {
    return  [
        {
            name: 'nps',
            label: 'NPS',
        },
        {
            name: 'csat',
            label: 'CSAT',
        },
        {
            name: 'fivestar',
            label: 'Five Star',
        },
    ]
}
